import { createLogger } from '@platform/observability';
import { env } from './config/runtime';

export const logger = createLogger({ level: env.logLevel });
